<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 financeTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="report-config"
                        arrows >
                    <template slot="gofixTab:report-config">
                        <div class="d-flex justify-content-end align-items-center mb-3">
                            <gofix-button @click="saveData" :loading="loading" label="Save"></gofix-button>
                        </div>
                        <gofix-card title=" " classHeader="mb-5" classContent="mb-0">
                            <b-row>
                                <b-col cols="4">
                                    <gofix-form-dropdown
                                        label="Report"
                                        vLabel="reference_value_text"
                                        required
                                        :reduce="option => option.id"
                                        :options="report_types"
                                        v-model="data.reference_id">
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card title="Companies">
                            <template slot="gofixCard:right_header">
                                <gofix-button label=" " @click="showModalCompanyAddress" noBorder>
                                    <template slot="gofix:button:beforeLabel">
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                        </svg>
                                    </template>
                                </gofix-button>
                            </template>
                            <b-row>
                                <template v-for="(item, index) in data.companies">
                                    <b-col class="mb-2" cols="4" :key="index">
                                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                                            <b-row>
                                                <b-col md="9" class="mb-15">
                                                    <gofix-text-field label="Name" oneline>
                                                        {{ item.name }}
                                                    </gofix-text-field>
                                                </b-col>
                                                <b-col md="3" class="mb-15 text-right">
                                                    <span class="editBox position-static cursor-pointer mr-12" @click="showModalCompanyAddress(item, index)">
                                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                                    </span>
                                                    <span class="editBox position-static cursor-pointer" @click="removeCompanyAddress(item, index)">
                                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                                    </span>
                                                </b-col>
                                                <b-col md="12">
                                                    <gofix-text-field label="Address" oneline>
                                                        <span style="white-space: pre-line;" v-html="item.address"></span>
                                                    </gofix-text-field>
                                                </b-col>
                                            </b-row>
                                        </gofix-card>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Company Name & Address" hide-footer :centered="true" v-model="modal.company_address.open">
                                <b-form class="pb-10">
                                    <gofix-form-input label="Name" v-model="modal.company_address.data.name"></gofix-form-input>
                                    <gofix-form-input-textarea 
                                        label="Address" 
                                        class="mb-0 h-100" 
                                        :rows="5"
                                        v-model="modal.company_address.data.address" />
                                </b-form>   
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="SAVE" @click="saveCompanyAddress" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                        <gofix-card title="Attention to">
                            <template slot="gofixCard:right_header">
                                <gofix-button label=" " @click="showModalAttention" noBorder>
                                    <template slot="gofix:button:beforeLabel">
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                        </svg>
                                    </template>
                                </gofix-button>
                            </template>
                            <b-row>
                                <template v-for="(item, index) in data.attentions">
                                    <b-col class="mb-2" cols="4" :key="index">
                                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                                            <b-row>
                                                <b-col md="9"  class="mb-15">
                                                    <gofix-text-field label="Attention to" oneline>
                                                        {{ item.name }}
                                                    </gofix-text-field>
                                                </b-col>
                                                <b-col md="3" class="mb-15 text-right">
                                                    <span class="editBox position-static cursor-pointer mr-12" @click="showModalAttention(item, index)">
                                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                                    </span>
                                                    <span class="editBox position-static cursor-pointer" @click="removeAttention(item, index)">
                                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                                    </span>
                                                </b-col>
                                                <b-col md="12">
                                                    <gofix-text-field label="Company" oneline>
                                                        {{ item.company && item.company.name ? item.company.name : null }}
                                                    </gofix-text-field>
                                                </b-col>
                                            </b-row>
                                        </gofix-card>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Attention to" hide-footer :centered="true" v-model="modal.attention_to.open">
                                <b-form class="pb-10">
                                    <gofix-form-input label="Attention to" v-model="modal.attention_to.data.name"></gofix-form-input>
                                </b-form>
                                <gofix-form-dropdown
                                    label="Company"
                                    vLabel="name"
                                    append-to-body
                                    v-model="modal.attention_to.data.company"
                                    :options='modal.attention_to.companies'
                                >
                                </gofix-form-dropdown>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="SAVE" @click="saveAttention" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                        <gofix-card title="Reporter Name & Designation">
                            <template slot="gofixCard:right_header">
                                <gofix-button label=" " @click="showModalReporter" noBorder>
                                    <template slot="gofix:button:beforeLabel">
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                        </svg>
                                    </template>
                                </gofix-button>
                            </template>
                            <b-row>
                                <template v-for="(item, index) in data.reporters">
                                    <b-col class="mb-2" cols="4" :key="index">
                                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                                            <b-row>
                                                <b-col md="9" class="mb-15">
                                                    <gofix-text-field label="Person TC Name" oneline>
                                                        {{ item.person_tc_name }}
                                                    </gofix-text-field>
                                                </b-col>
                                                <b-col md="3" class="mb-15 text-right">
                                                    <span class="editBox position-static cursor-pointer mr-12" @click="showModalReporter(item, index)">
                                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                                    </span>
                                                    <span class="editBox position-static cursor-pointer" @click="removeReporter(index)">
                                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                                    </span>
                                                </b-col>
                                                <b-col md="12">
                                                    <gofix-text-field label="Description" oneline>
                                                        {{ item.description }}
                                                    </gofix-text-field>
                                                </b-col>
                                            </b-row>
                                        </gofix-card>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Reporter Name & Designation" hide-footer :centered="true" v-model="modal.reporter.open">
                                <b-form class="pb-10">
                                    <gofix-form-input label="Person TC Name" v-model="modal.reporter.data.person_tc_name" />
                                    <gofix-form-input-textarea 
                                        label="Description" 
                                        class="h-100" 
                                        :rows="4"
                                        v-model="modal.reporter.data.description" />
                                </b-form>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="SAVE" @click="saveReporter" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                        <gofix-card title="Recipients">
                            <template slot="gofixCard:right_header">
                                <gofix-button label=" " @click="showModalContactables" noBorder>
                                    <template slot="gofix:button:beforeLabel">
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                        </svg>
                                    </template>
                                </gofix-button>
                            </template>
                            <b-row>
                                <template v-for="(item, index) in data.contactables">
                                    <b-col class="mb-2" cols="4" :key="index">
                                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                                            <b-row>
                                                <b-col md="9"  class="mb-15">
                                                    <gofix-text-field label="Email" oneline>
                                                        {{ item.email }}
                                                    </gofix-text-field>
                                                </b-col>
                                                <b-col md="3" class="mb-15 text-right">
                                                    <span class="editBox position-static cursor-pointer mr-12" @click="showModalContactables(item, index)">
                                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                                    </span>
                                                    <span class="editBox position-static cursor-pointer" @click="removeContactables(item, index)">
                                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                                    </span>
                                                </b-col>
                                                <b-col md="12" class="mb-15">
                                                    <gofix-text-field label="Name" oneline>
                                                        {{ item.name }}
                                                    </gofix-text-field>
                                                </b-col>
                                                <b-col md="12">
                                                    <gofix-text-field label="Company" oneline>
                                                        {{ item.company && item.company.name ? item.company.name : null }}
                                                    </gofix-text-field>
                                                </b-col>
                                            </b-row>
                                        </gofix-card>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Recipients" hide-footer :centered="true" v-model="modal.contactable.open">
                                <b-form class="pb-10">
                                    <gofix-form-input label="Email" v-model="modal.contactable.data.email" required show-icon-required></gofix-form-input>
                                    <gofix-form-input label="Name" v-model="modal.contactable.data.name"></gofix-form-input>
                                    <gofix-form-dropdown
                                        label="Company"
                                        vLabel="name"
                                        append-to-body
                                        v-model="modal.contactable.data.company"
                                        :options='modal.contactable.companies'
                                    >
                                    </gofix-form-dropdown>
                                </b-form>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="SAVE" @click="saveContactables" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    export default {
        name: 'contract-settings-lift-inspection-report',
        data() {
            return {
                loading: false,
                timer: null,
                contract_tab: tabData.client_contract,
                report_types: [],
                data: {
                    company_name: '',
                    address: '',
                    person_name: '',
                    person_tc_name: '',
                    description: '',
                    contract_id: this.$route.params.id,
                    reference_id: '',
                    reporters: [],
                    attentions: [],
                    companies: [],
                    contactables: []
                },
                del_company_ids: [],
                del_attention_ids: [],
                del_contactable_ids: [],
                modal: {
                    attention_to: {
                        open: false,
                        companies: [],
                        data: {
                            index: null,
                            name: null,
                            company: null
                        }
                    },
                    reporter: {
                        open: false,
                        data: {
                            index: null,
                            person_tc_name: null,
                            description: null
                        }
                    },
                    company_address: {
                        open: false,
                        data: {
                            index: null,
                            name: null,
                            address: null
                        }
                    },
                    contactable: {
                        open: false,
                        companies: [],
                        data: {
                            index: null,
                            name: null,
                            email: null,
                            company: null
                        }
                    },
                }
            }
        },
        computed: {
            ...mapGetters({
                clientContractID: 'ContractController/ClientContractID'
            }),
        },
        watch: {
            clientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }
                if ((old && old.id) && (val && val.id) && val.id != old.id) {
                    this.data.contract_id = this.$route.params.id;
                    this.getSettings();
                }
            },
            "data.reference_id": function(val) {
                if(val)
                    this.getSettings();
                else {
                    this.data = {
                        company_name: '',
                        address: '',
                        person_name: '',
                        person_tc_name: '',
                        description: '',
                        contract_id: this.$route.params.id,
                        reference_id: '',
                        reporters: [],
                        attentions: [],
                        companies: [],
                        contactables: []
                    }
                }
            }
        },
        created() {
            if (!this.$route.params.hasOwnProperty('id') || this.$route.params.id == "0" || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-client`);
            }

            this.getReportType();
        },
        methods: {
            getReportType(){
                this.$store.dispatch("ReferenceController/getItems", {
                    limit:-1,
                    page:1,
                    filter: {
                        reference_type:"Report Type",
                    },
                }).then(response => {
                    if(response.items.length)
                        this.data.reference_id = response.items[0].id;
                    this.report_types = response.items;
                });
            },
            getSettings() {
                this.$store.dispatch("LiftInspectionReportController/getSettingsForLiftInspectionReport", {
                    contract_id: this.$route.params.id,
                    reference_id: this.data.reference_id
                })
                .then(result => {
                    if(result) {
                        this.data = {
                            ...this.data,
                            ...result
                        }
                        if (!this.data.attentions) this.data.attentions = [];
                        if (!this.data.reporters) this.data.reporters = [];
                        if (!this.data.companies) this.data.companies = [];
                        if (!this.data.contactables) this.data.contactables = [];
                    } else {
                        this.data = {
                            company_name: '',
                            address: '',
                            person_name: '',
                            person_tc_name: '',
                            description: '',
                            contract_id: this.$route.params.id,
                            reference_id: this.report_types.length ? this.report_types[0].id : '',
                            reporters: [],
                            attentions: [],
                            companies: [],
                            contactables: []
                        }
                    }
                    this.getLiftReportCompanies();
                }).catch(err => {
                    console.log(err);
                });
            },
            saveData() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if(!this.data.reference_id) {
                        return this.$alertNotification("Report is required", "danger");
                    }

                    if(this.loading) return;
                    this.loading = true;
                    let request = JSON.parse(JSON.stringify(this.data));
                    request.attentions = request.attentions;
                    // request.reporters = request.id ? JSON.stringify(request.reporters) : request.reporters;
                    request.reporters = request.reporters;
                    request.companies = request.companies;
                    request.contactables = request.contactables;
                    request.del_company_ids = this.del_company_ids;
                    request.del_attention_ids = this.del_attention_ids;
                    request.del_contactable_ids = this.del_contactable_ids;
                    delete request.id;
                    this.$store.dispatch(`LiftInspectionReportController/storeSettingsForLiftInspectionReport`, request)
                    .then(response => {
                        this.loading = false;
                        this.del_company_ids = [];
                        this.del_attention_ids = [];
                        this.del_contactable_ids = [];
                        this.getSettings();
                        this.$alertNotification(this.$notificationV2('editing', 'setting_lift_inspection_report'));
                     })
                    .catch(err => {
                        this.loading = false;
                    })
                }, 300);
            },
            showModalAttention(item = null, index = null) {
                this.modal.attention_to.data = {
                    index: index,
                    ...item
                }
                this.modal.attention_to.open = true;
            },
            removeAttention(item, index) {
                if(item.id) this.del_attention_ids.push(item.id)
                this.$delete(this.data.attentions, index);
            },
            saveAttention() {
                this.modal.attention_to.open = false;
                if(this.modal.attention_to.data.index == null) {
                    this.data.attentions.push(this.modal.attention_to.data);
                    return
                }
                
                if(this.data.attentions[this.modal.attention_to.data.index]) {
                    this.data.attentions[this.modal.attention_to.data.index] = Object.assign(this.data.attentions[this.modal.attention_to.data.index], this.modal.attention_to.data);
                }
            },
            showModalReporter(item = null, index = null) {
                this.modal.reporter.data = {
                    index: index,
                    person_tc_name: item && item.person_tc_name ? item.person_tc_name : null,
                    description: item && item.description ? item.description : null
                }
                this.modal.reporter.open = true;
            },
            removeReporter(index) {
                this.$delete(this.data.reporters, index);
            },
            saveReporter() {
                this.modal.reporter.open = false;
                if(this.modal.reporter.data.index == null) {
                    this.data.reporters.push({
                        person_tc_name: this.modal.reporter.data.person_tc_name,
                        description: this.modal.reporter.data.description
                    });
                    return
                }
                
                if(this.data.reporters[this.modal.reporter.data.index]) {
                    this.data.reporters[this.modal.reporter.data.index] = {
                        person_tc_name: this.modal.reporter.data.person_tc_name,
                        description: this.modal.reporter.data.description
                    };
                }
            },
            showModalCompanyAddress(item = null, index = null) {
                this.modal.company_address.data = {
                    index: index,
                    ...item
                }
                this.modal.company_address.open = true;
            },
            removeCompanyAddress(item, index) {
                if(item.id) this.del_company_ids.push(item.id)
                this.$delete(this.data.companies, index);
            },
            saveCompanyAddress() {
                this.modal.company_address.open = false;
                if(this.modal.company_address.data.index == null) {
                    this.data.companies.push({
                        name: this.modal.company_address.data.name,
                        address: this.modal.company_address.data.address,
                    });
                    return
                }
                
                if(this.data.companies[this.modal.company_address.data.index]) {
                    this.data.companies[this.modal.company_address.data.index] = Object.assign(this.data.companies[this.modal.company_address.data.index], {
                        name: this.modal.company_address.data.name,
                        address: this.modal.company_address.data.address
                    });
                }
            },
            // Company
            getLiftReportCompanies() {
                if(!this.data.id) return this.data.companies = [];
                this.$store.dispatch("LiftInspectionReportController/getLiftReportCompanies", {
                    report_config_id: this.data.id
                })
                .then(result => {
                    this.modal.attention_to.companies = this.modal.contactable.companies = result;
                }).catch(err => {
                    console.log(err);
                });
            },
            // Contactables
            removeContactables(item, index) {
                if(item.id) this.del_contactable_ids.push(item.id)
                this.$delete(this.data.contactables, index);
            },
            saveContactables() {
                if(!this.modal.contactable.data.email) return this.$alertNotification("Email is required.", "danger");
                if(!this.emailValidationCheckFormat(this.modal.contactable.data.email)) {
                    return this.$alertNotification("Email is not in a correct format.", "danger");
                }
                this.modal.contactable.open = false;
                if(this.modal.contactable.data.index == null) {
                    this.data.contactables.push(this.modal.contactable.data);
                    return
                }
                
                if(this.data.contactables[this.modal.contactable.data.index]) {
                    this.data.contactables[this.modal.contactable.data.index] = Object.assign(this.data.contactables[this.modal.contactable.data.index], this.modal.contactable.data);
                }
            },
            showModalContactables(item = null, index = null) {
                this.modal.contactable.data = {
                    index: index,
                    ...item
                }
                this.modal.contactable.open = true;
            },
            /*-- Validation Data --------*/
            emailValidationCheckFormat(email_address){
                if(email_address && email_address != ''){
                    let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                    let result = pattern.test(email_address);
                    return result;
                }
                return true;
            },
        }
    }
</script>
